const orderItems = JSON.parse(localStorage.getItem('orderItems'));
let palletCountMultiplier = 'Stanard';
let basketUnits = 0;
let palletCountLightGlobal = 1;
let palletCountStandardGlobal = 1;
let palletCountHeavyGlobal = 1;

// *************************************
// Cart notification widget
// **************************************

function updateCartCount() {
  let orderItemsCount = JSON.parse(localStorage.getItem('orderItems'));
  orderItemsCount = orderItemsCount.length;

  if (orderItemsCount > 0) {
    $('.cart-link__total').text(orderItemsCount);
    if (window.location.pathname == '/wire-baskets/order') {
      return true;
    }
    if (orderItemsCount == 1) {
      $('.cart-link__text').text('item in order');
    } else {
      $('.cart-link__text').text('items in order');
    }
    $('.cart-link').show();
  }
}

// Run it on page load
if (orderItems != null) {
  updateCartCount();
}

// *************************************
// Product and Finder page
// **************************************

function resetOrderDialogFields() {
  // reset the fields
  $('.dialog #basket-categories').val('');
  $('.dialog #top-size').val('');
  $('.dialog #taper').val('');
  $('.dialog #grade').blur();
  $('.dialog #quantity').val(0);
  $('.dialog #burlap_type').blur();
  $('.dialog #burlap_treatment').blur();
  $('.dialog #burlap_grade').blur();
  $('.dialog #burlap_quantity').val(0);
  $('.dialog .burlap-type-container').remove();
  $('.dialog .basket-unit-count__data').text('');
  $('.dialog .burlap-unit-count__data').text('');
  console.log('form cleared');
}

function openAddtoOrderDialog({
  basketCategories,
  productCategory = 'basket',
  selectedBottomType,
  bottomTypes,
  topSize,
  taper,
  palletCountLight,
  palletCountStandard,
  palletCountHeavy,
  burlapLiner,
  burlapSquare
}) {
  resetOrderDialogFields();

  if (productCategory == 'basket') {
    palletCountLightGlobal = palletCountLight;
    palletCountStandardGlobal = palletCountStandard;
    palletCountHeavyGlobal = palletCountHeavy;

    $('.dialog #basket-categories').val(basketCategories);
    $('.dialog #top-size').val(topSize);
    $('.dialog #taper').val(taper);

    let burlapOptions = `<option value="Unselected">Select Burlap Type</options>`;
    if (burlapLiner) {
      burlapOptions += `<option value="Liner ${burlapLiner}">Liner: ${burlapLiner}</option>`;
    }
    if (burlapSquare) {
      burlapOptions += `<option value="Square ${burlapSquare}">Square: ${burlapSquare}</option>`;
    }
    if (burlapLiner || burlapSquare) {
      $(`
                <div class="my-1 burlap-type-container">
                    <div class="relative">
                        <select autocomplete="off" class="appearance-none px-1 py-1 bg-grey-200 text-center w-full" name="burlap_type" id="burlap_type">
                            ${burlapOptions}
                        </select>
                        <div class="pointer-events-none absolute pin-y pin-r flex items-center px-.5 text-grey-darker">
                            <svg class="fill-current h-1 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path></svg>
                        </div>
                    </div>
                </div>
                `).insertAfter('.burlap-options-heading');
    } else {
      $('.dialog #burlap_type').remove();
    }

    // add bottom types
    // bottom type has been selected externally
    if (selectedBottomType) {
      $('.dialog__inner--add-item').append(`<input id="bottom-type" type="hidden" name="bottom-type" value="${selectedBottomType}" >`);
      // we need to select a bottom type still
    } else {
      $('.bottom-type-container').remove(); // if there was one from before
      $(`
                <div class="py-1 bottom-type-container">
                    <div class="relative">
                        <select autocomplete="off" class="appearance-none pl-1 py-1 pr-2 bg-grey-200 text-center w-full" name="bottom-type" id="bottom-type">
                            <option value="Unselected">Select Bottom Type</option>
                        </select>
                        <div class="pointer-events-none absolute pin-y pin-r flex items-center px-.5 text-grey-darker">
                                <svg class="fill-current h-1 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            </div>
                        </div>
                    </div>
                </div>
            `).insertAfter('.dialog__title');
      for (let i = 0; i <= bottomTypes.length - 1; i++) {
        $('.dialog #bottom-type').append(`<option value="${bottomTypes[i]}">${bottomTypes[i]}</option>`);
      }
    }

    // Burlap product
  } else if (productCategory == 'burlap') {
    $('.dialog .basket-grade-container').hide();
    $('.dialog .basket-quantity-container').hide();
    $('.dialog #burlap').blur();
    $('.dialog__title').text('Burlap Options');
    $(`
        <div class="my-1 burlap-type-container">
            <div class="relative">
                <select autocomplete="off" class="appearance-none px-1 py-1 bg-grey-200 text-center w-full" name="burlap_type" id="burlap_type">
                    <option value="Unselected">Select Burlap Type</options>
                    <option value="Liners">Liners</option>
                    <option value="Squares">Squares</option>
                </select>
                <div class="pointer-events-none absolute pin-y pin-r flex items-center px-.5 text-grey-darker">
                    <svg class="fill-current h-1 w-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path></svg>
                </div>
            </div>
        </div>
        `).insertAfter('.burlap-options-heading');
    $('.burlap-options-heading ').hide();
  }

  $('.dialog').fadeIn(200);
}

function addItemToStorage({ productCategory = 'basket' }) {
  const orderItems = JSON.parse(localStorage.getItem('orderItems')) || [];
  const newItemId = orderItems.length + 1;
  let newItem = '';

  const burlap = $('.dialog #burlap').val();
  const burlapType = $('.dialog #burlap_type').val();
  const burlapTreatment = $('.dialog #burlap_treatment').val();
  const burlapGrade = $('.dialog #burlap_grade').val();
  const burlapQuantity = $('.dialog #burlap_quantity').val();

  if (productCategory == 'basket') {
    const basketCategory = $('.dialog #basket-categories').val();
    const topSize = $('.dialog #top-size').val();
    const taper = $('.dialog #taper').val();
    const bottomType = $('.dialog #bottom-type').val();

    const grade = $('.dialog #grade').val();
    const quantity = $('.dialog #quantity').val();

    newItem = {
      orderItem: {
        id: newItemId,
        productCategory,
        basketCategory,
        topSize,
        taper,
        bottomType,
        grade,
        burlap,
        quantity,
        basketUnits,
        burlapType,
        burlapTreatment,
        burlapGrade,
        burlapQuantity
      }
    };
  } else if (productCategory == 'burlap') {
    const burlap = $('.dialog #burlap').val();
    const quantity = $('.dialog #quantity').val();

    newItem = {
      orderItem: {
        id: newItemId,
        productCategory,
        burlap,
        burlapType,
        burlapTreatment,
        burlapGrade,
        burlapQuantity
      }
    };
  } else {
    return false;
  }

  orderItems.push(newItem);

  localStorage.setItem('orderItems', JSON.stringify(orderItems));

  showItemAddedConfirmation();
  updateCartCount();
}

function showItemAddedConfirmation() {
  $('.dialog__inner--add-item').fadeOut(300, function() {
    $('.dialog__inner--add-item-confirmation').show();
  });
}

function calculatePalletAmount() {
  switch ($('.dialog #grade').val()) {
    case 'Light Grade':
      palletCountMultiplier = palletCountLightGlobal;
      break;
    case 'Heavy Grade':
      palletCountMultiplier = palletCountHeavyGlobal;
      break;
    default:
      palletCountMultiplier = palletCountStandardGlobal;
  }

  basketUnits = palletCountMultiplier * $('.dialog #quantity').val();
  if (!basketUnits) {
    basketUnits = 'TBD';
  }
  if ($('.dialog #quantity').val() > 0) {
    $('.basket-unit-count').show();
    $('.basket-unit-count__data').text(basketUnits + ' pieces');
  } else {
    $('.basket-unit-count').hide();
  }
}

// Events

$(document).on('keyup', function(e) {
  if (e.keyCode == 27) {
    $('.dialog').fadeOut(200);
  }
  return false;
});

$('.js-dialog-add-to-order-btn').on('click', function() {
  const productCategory = $(this).data('product-category');
  addItemToStorage({ productCategory: productCategory });
  $('.bottom-type-container').remove();
  $('.dialog__continue').fadeIn();
});

$('body').on('click', 'a.js-add-to-order-btn', function() {
  $('.dialog__inner--add-item').show();
  $('.dialog__inner--add-item-confirmation').hide();

  let selectedBottomType;

  if ($('.js-basket-finder-input-bottom-type.selected').length) {
    selectedBottomType = $('.js-basket-finder-input-bottom-type.selected').data('bottom-type');
  }

  let basketCategories;

  if ($(this).data('basket-categories')) {
    basketCategories = $(this).data('basket-categories');
  } else {
    basketCategories = $('.page-title').text(); // grabbing from the dom, how embarrassing.
  }

  let bottomTypes = $(this).data('bottom-types');

  bottomTypes = bottomTypes.split(',');

  openAddtoOrderDialog({
    basketCategories: basketCategories,
    bottomTypes: bottomTypes,
    burlapLiner: $(this).data('burlap-liner'),
    burlapSquare: $(this).data('burlap-square'),
    palletCountHeavy: $(this).data('pallet-count-heavy'),
    palletCountLight: $(this).data('pallet-count-light'),
    palletCountStandard: $(this).data('pallet-count-standard'),
    productCategory: 'basket',
    selectedBottomType: selectedBottomType,
    topSize: $(this).data('top-size'),
    taper: $(this).data('taper')
  });
  return false;
});

$('.js-dialog-close, .dialog__bg').on('click', function() {
  $('.dialog').fadeOut(200);
  return false;
});

$('.dialog__continue').on('click', function() {
  $('.dialog').fadeOut(200);
  return false;
});

$('.dialog #grade').on('change', function() {
  calculatePalletAmount();
});

$('.dialog #quantity').on('change', function() {
  calculatePalletAmount();
});

// *************************************
// Burlap product page
// **************************************

$('.btn--burlap').on('click', function() {
  //open order dialog
  console.log('opening');
  openAddtoOrderDialog({
    productCategory: 'burlap',
    bottomTypes: undefined
  });
});

$('.dialog #burlap_quantity').on('change', function() {
  let units = $(this).val();
  units = '(' + units * 500 + ') pieces';
  $('.burlap-unit-count__data').text(units);
});

$('.js-run-basket-search').on('click', function(e) {
  e.preventDefault;
  resetOrderDialogFields();
  return false;
});
